var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-container',[_c('h1',{staticClass:"mt-4 text-center"},[_vm._v("This page has't implemented yet")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }